// 📄 components/StepIsuBte.tsx
import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { InvoiceStatusFormData } from '../../../../../services/commerce/integrationService';

interface StepIsuBteProps {
  bteProductActive: boolean;
  bteProcess: string;
  bteFunctionModule: string;
  onChange: (field: keyof InvoiceStatusFormData, value: any) => void;
  isInvalid: boolean;
}

export function StepIsuBte({ bteProductActive, bteProcess, bteFunctionModule, onChange, isInvalid }: StepIsuBteProps) {
  return (
    <div className="space-y-4 animate-fadeIn">
      <div className="bg-blue-500/5 border border-blue-500/10 rounded-xl p-3 mb-2 space-y-1">
        <span className="text-[10px] font-bold text-blue-400 uppercase tracking-widest block">Ruta SPRO / Transacción SAP</span>
        <p className="font-mono text-xs text-gray-300">
          <span className="bg-zinc-800 px-1.5 py-0.5 rounded text-gray-400 font-bold mr-1.5">FIBF</span>
          <span>SAP Menu → Financial Accounting → Business Transaction Events → Settings → Products / P_S / Process Modules</span>
        </p>
      </div>

      <div>
        <h3 className="text-lg font-medium text-blue-400">2. Configure BTE (Business Transaction Events)</h3>
        <p className="text-sm text-gray-400">
          Activa el producto BTE del Add-on y asocia el proceso al módulo de función que publica el estatus de la factura hacia SAP Ariba.
        </p>
      </div>

      <div className="bg-white/5 p-4 rounded-xl border border-white/5 space-y-4">
        <div className="flex items-center justify-between gap-4">
          <div>
            <label className="block text-sm font-medium text-white">Producto <code className="bg-black/30 px-1 rounded font-mono text-blue-400">ARBCIGIS</code> (<code className="bg-black/30 px-1 rounded font-mono">ARBCIG_ISU</code>) activo</label>
            <p className="text-xs text-gray-400 mt-0.5">FIBF → Settings → Products → Of a Customer</p>
          </div>
          <label className="relative inline-flex items-center cursor-pointer flex-shrink-0">
            <input type="checkbox" checked={bteProductActive || false} onChange={(e) => onChange('bteProductActive', e.target.checked)} className="sr-only peer" />
            <div className="w-9 h-5 bg-zinc-700 rounded-full peer peer-checked:after:translate-x-full peer-checked:bg-blue-500 after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:rounded-full after:h-4 after:w-4 after:transition-all"></div>
          </label>
        </div>

        <div className="border-t border-white/5 pt-3 grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-xs font-medium text-gray-400 mb-1">
              Process BTE <span className="text-red-400">*</span>
            </label>
            <input
              type="text"
              value={bteProcess}
              onChange={(e) => onChange('bteProcess', e.target.value.replace(/[^0-9]/g, ''))}
              placeholder="00005010"
              maxLength={8}
              className={`w-full bg-zinc-800 border rounded-lg p-2.5 text-sm font-mono text-white focus:outline-none focus:border-blue-500 ${
                isInvalid && !bteProcess ? 'border-red-500' : 'border-white/10'
              }`}
            />
          </div>

          <div>
            <label className="block text-xs font-medium text-gray-400 mb-1">Function Module</label>
            <input
              type="text"
              value={bteFunctionModule}
              onChange={(e) => onChange('bteFunctionModule', e.target.value.toUpperCase())}
              placeholder="ARBCIG_BTE_00005010"
              className="w-full bg-zinc-800 border border-white/10 rounded-lg p-2.5 text-sm font-mono text-white focus:outline-none focus:border-blue-500"
            />
          </div>
        </div>
      </div>

      <div className="bg-yellow-500/10 border border-yellow-500/20 rounded-xl p-4 text-yellow-400 flex gap-3 text-sm">
        <AlertTriangle className="w-5 h-5 flex-shrink-0" />
        <div>
          <p className="font-semibold">Un solo Function Module por proceso</p>
          <p className="text-xs text-yellow-500/80 mt-0.5">
            Si el cliente ya usa el proceso <code className="bg-black/30 px-1 rounded">00005010</code> para otro desarrollo Z, valida que no haya conflicto antes de asignar este Function Module.
          </p>
        </div>
      </div>
    </div>
  );
}
